import { render, staticRenderFns } from "./blogs.vue?vue&type=template&id=d04845aa&scoped=true"
import script from "./blogs.vue?vue&type=script&lang=js"
export * from "./blogs.vue?vue&type=script&lang=js"
import style0 from "./blogs.vue?vue&type=style&index=0&id=d04845aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04845aa",
  null
  
)

export default component.exports